module.exports = __webpack_public_path__ + "images/psp/SizeGuide/motorcycle/10x10.svg";